import React, { useEffect, useState } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { format } from "date-fns";

import CardImage from "../../atoms/cardimage";
import CustomStoryCard3 from "../../molecules/custom-story-card3";
import CustomStoryCard4 from "../../molecules/custom-story-card4";
import { Standard300x260Container, Standard337x280Container } from "../../rows/ad-free";

import { getTotalCountOfEachCollection } from "../../helper/api";
import translate from "../../translate";

import "./snapshot.m.css";

const Snapshot = ({ collection, publisherName, pageType, currentPath }) => {
  const [remainingStoryCount, setRemainingStoryCount] = useState("");

  if (!(collection && collection.items)) {
    return null;
  }
  const snapshotBody = get(collection, ["metadata", "snapshot", "body"], null);
  const updatedAt = collection["created-at"] ? format(collection["created-at"], "dd.MM.yy") : "";

  const stories = collection.items.filter((item) => item.type === "story").map((item) => item.story);
  if (!stories.length) {
    return null;
  }

  useEffect(() => {
    getTotalCountOfEachCollection(collection.slug, 0).then((result) =>
      setRemainingStoryCount(result["total-count"] - 4)
    );
  }, []);

  const getSlug = () => {
    if (pageType === "section-page" || pageType === "big-story-section-page") {
      return `${currentPath}/${collection.slug}`;
    }

    return collection.slug;
  };

  const [firstStory, ...remainingStories] = stories.slice(0, 4);

  return (
    <div styleName="wrapper" className="container" id={collection.slug}>
      <div styleName="header-wrapper">
        <div styleName="header-content">
          <Link href={getSlug()}>
            <div styleName="collection-name">{collection.name}</div>
          </Link>
          <div styleName="collection-summary">{collection.summary}</div>
          <div styleName="updated-at">{`UPDATED ${updatedAt}`}</div>
        </div>
      </div>

      <div styleName="desktop-wrapper">
        <div styleName="left-desktop-content">
          <div styleName="snapshot-label">{translate(publisherName, "snapshot")}</div>
          <div styleName="snapshot-stories" dangerouslySetInnerHTML={{ __html: snapshotBody }} />
        </div>

        <div styleName="right-desktop-content">
          <div styleName="image-with-ad">
            <Link href={firstStory.url}>
              <CardImage
                story={firstStory}
                aspectRatio={[3, 2]}
                imageType="image3x2"
                widths={[430]}
                eager={true}
                showHeadline={true}
                showStoryTypeIcon
              />
            </Link>

            <div styleName="desktop-ad">
              <Standard300x260Container id="rightATF" />
            </div>
          </div>

          <div styleName="row-stories">
            {remainingStories.map((item, index) => (
              <CustomStoryCard4 story={item} key={index} />
            ))}
          </div>
        </div>
      </div>

      <div styleName="mobile-wrapper">
        <div styleName="read-snapshot-label">{translate(publisherName, "read_snapshot")}</div>

        <div styleName="mobile-stories">
          <CustomStoryCard3
            story={firstStory}
            imageType="image4x3"
            aspectRatio={[4, 3]}
            widths={[90]}
            headerType={4}
            showHeadlineIcon
          />
          {remainingStories.map((item, index) => (
            <CustomStoryCard3
              key={index}
              story={item}
              imageType="image4x3"
              aspectRatio={[4, 3]}
              widths={[90]}
              headerType={4}
              showHeadlineIcon
            />
          ))}
        </div>

        <div styleName="mobile-footer-wrapper">
          <div styleName="mobile-footer-content">
            <div styleName="empty-div"></div>
          </div>
        </div>

        <div styleName="mobile-ad">
          <Standard337x280Container id="mid1" type="mobile" />
        </div>
      </div>

      <div styleName="desktop-footer-wrapper">
        <div styleName="desktop-footer-content">
          <Link href={getSlug()} styleName="collection-link">
            {remainingStoryCount} {translate(publisherName, "more")} / {translate(publisherName, "view_all")}
          </Link>
        </div>
      </div>
    </div>
  );
};

Snapshot.propTypes = {
  collection: object.isRequired,
  publisherName: string,
  currentPath: string,
  pageType: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
  currentPath: get(state, ["qt", "currentPath"], null),
  pageType: get(state, ["qt", "pageType"], null),
});

export default connect(mapStateToProps, null)(Snapshot);
